import { PHONE_DISPLAY, PHONE_NUMBER, WHATSAPP_LINK, WHATSAPP_NUMBER } from '@/constants/contact';
import { OFFICIAL_INSTAGRAM_PROFILE_URL } from '@/constants/social';

/** Default public contact & brand — override with Vite env where set */
export const brand = {
  name: 'Workshops by Aabha',
  shortTagline: 'Gather · Create · Glow',
  /** public/assets/images/logo-transparent.png */
  logoSrc: '/assets/images/logo-transparent.png?v=7',
  logoAlt: 'Aabha — Gather. Create. Glow',
  phoneDisplay: PHONE_DISPLAY,
  phoneTel: PHONE_NUMBER,
  waDigits: WHATSAPP_NUMBER,
  email: 'connectusaabha@gmail.com',
  instagramHandle: '@workshopsbyaabha',
  instagramUrl: OFFICIAL_INSTAGRAM_PROFILE_URL,
  citiesLine: 'Rooted in Bengaluru, curating experiences across India.',
};

const whatsappDefaultMessage = "Hi Aabha, I'm interested in your workshops";
export const whatsappLink = (message = whatsappDefaultMessage) =>
  `https://wa.me/${brand.waDigits}?text=${encodeURIComponent(message)}`;
export const whatsappUrl = WHATSAPP_LINK;
export const contactEmail = import.meta.env.VITE_CONTACT_EMAIL || brand.email;
export const contactPhoneDisplay = import.meta.env.VITE_CONTACT_PHONE || brand.phoneDisplay;
/** Always the official profile — env cannot override (prevents wrong deploys). */
export const instagramUrl = OFFICIAL_INSTAGRAM_PROFILE_URL;
